import { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { faAnglesLeft, faBars } from '@fortawesome/free-solid-svg-icons';
import UnifiedTopBar from '@frontend/Components/TopBar/UnifiedTopBar';
import { createDetailViewTemplate } from '@frontend/Components/TopBar/templates';
import MatterService from '@frontend/AppSettings/services/MatterService';
import FileList from "./file-list";
import { detailRouteBase, detailRoutePrefix } from '../../utils/detailRoute';
import "./Files.css";
import { isLegalEnvironment } from '@frontend/AppSettings/environmentConfig';

const Files = () => {
  const { matterId } = useParams<{ matterId: string }>();
  const navigate = useNavigate();
  const [matterName, setMatterName] = useState<{ mattername?: string } | null>(null);

  const fetchMatterName = useCallback(async () => {
    if (matterId) {
      try {
        const response = await MatterService.getMatterName(matterId);
        setMatterName(response || null);
      } catch (error) {
        console.error('Error fetching matter name:', error);
        setMatterName(null);
      }
    }
  }, [matterId]);

  useEffect(() => {
    fetchMatterName();
  }, [fetchMatterName]);

  const handleSearch = (search: string, filter?: string | null) => {
    // Search functionality can be implemented when needed
    console.log('Search:', search, filter);
  };

  const matterTitle = matterName?.mattername
    ? `${matterId} - ${matterName.mattername}`
    : 'Loading...';

  const dropdownItems = [
    { label: 'General', onClick: () => navigate(`${detailRouteBase()}/${matterId}`) },
    { label: 'Tasks', onClick: () => navigate(`${detailRouteBase()}/${matterId}/tasks`) },
    // Legal only: `/matterDetails/:matterId/financial/*` is registered inside App.js's
    // isLegalEnvironment block and has no engineering counterpart — engineering money lives on
    // the pipeline Commercial tab and /financials/*. detailRouteBase() resolves to
    // /projectDetails there, and with no catch-all route the tab rendered a blank page. The
    // retired project top bars carried four items and no Financial; the consolidation onto
    // these shared components is what surfaced it in the wrong vertical.
    ...(isLegalEnvironment
      ? [{ label: 'Financial', onClick: () => navigate(`${detailRouteBase()}/${matterId}/financial`) }]
      : []),
    { label: 'Files', onClick: () => navigate(`${detailRouteBase()}/${matterId}/files`) },
    { label: 'Notes', onClick: () => navigate(`${detailRouteBase()}/${matterId}/additionalNotes`) },
  ];

  const unifiedConfig = createDetailViewTemplate({
    leftExtras: [
      {
        type: 'button',
        icon: faAnglesLeft,
        onClick: () => navigate(`${detailRouteBase()}/${matterId}`),
        ariaLabel: 'Back to matter details',
      },
      {
        type: 'text',
        text: matterTitle,
        style: { marginLeft: '10px', fontWeight: 'bold' },
      },
    ],
    rightExtras: [
      {
        type: 'search',
        onSearch: handleSearch,
        columns: { Files: 'title' },
        defaultSelectedColumn: 'Files',
        placeholder: 'Search files',
      },
      {
        type: 'dropdown',
        trigger: {
          icon: faBars,
          ariaLabel: 'Matter sections',
        },
        items: dropdownItems,
      },
    ],
    pageContext: {
      route: `${detailRoutePrefix()}-files`,
      matterId,
      matterName: matterName?.mattername,
    },
  });

  return (
    <div className="filesPage">
      <UnifiedTopBar {...unifiedConfig} />
      {/* <div className="filesList">
        {filteredFilesData.map((file) => (
          <FileButton
            key={file.id}
            file={file}
            handleClick={handleClick}
            expandedFile={expandedFile}
          ></FileButton>
        ))}
      </div> */}
      {/* <div>
        {expandedFile ? (
          <div className="overlay">
            <div className="overlay-content">
              <button
                className="close-btn"
                onClick={() => {
                  setExpandedFile(null);
                }}
              >
                X
              </button>
              <div className="file-list">
                <FileTable data={innerFileData}></FileTable>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {expandedFile ? <FileTable data={innerFileData}></FileTable> : <></>}
        Current selected file id: {expandedFile}
      </div> */}
      <div>
        <FileList matterId={matterId} />
      </div>
    </div>
  );
};

export default Files;